<template lang="pug">
.sorter(:class="{ five }")
  label sort by
  button.az(@click="sort = 'AZ'", :class="{ selected: sort === 'AZ'  }") Number
  button(@click="sort = 'Weight'", :class="{ selected: !sort || sort === 'Weight'  }") Weight
  button(@click="sort = 'vis'", :class="{ selected: sort === 'vis'  }") Visuality
  button.age(@click="sort = 'age'", :class="{ selected: sort === 'age'  }") Age
  button.pos(v-if="five", @click="sort = 'pos'", :class="{ selected: sort === 'pos'  }") Positivity
  button.neg(v-if="five", @click="sort = 'neg'", :class="{ selected: sort === 'neg'  }") Negativity
</template>
<script>
export default {
  name: 'sorter',
  props: {
    path: String,
    five: Boolean,
  },
  computed: {
    sort: {
      get() {
        const { path, $store: { getters } } = this;
        console.log('sort path', path);
        return getters[path];
      },
      set(value) {
        const { path, $store: { dispatch } } = this;
        dispatch(path, value);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../scss/global';
.sorter {
  display: grid;
  justify-content: space-evenly;
  grid-template-columns: repeat(3, 1fr);
  color: inherit;
  padding-top: 1rem;
  padding-left: 0.125rem;
  padding-right: 0.25rem;
  &.five {
    grid-template-columns: repeat(5, 1fr);
    grid-column-gap: 0.25rem;
  }
  &.hide-az {
    button.az {
      display: none;
    }
  }
  &.hide-age {
    button.age {
      display: none;
    }
  }
  label {
    position: absolute;
    top: 0;
    left: 0.5rem;
    font-size: 0.8rem;
  }
  button {
    background-color: transparent;
    color: inherit;
    border: 1px solid transparent;
    border-radius: 0.125rem;
    box-sizing: border-box;
    width: 3.6rem;
    padding: 0.25rem 0;
    text-align: center;
    font-weight: bold;
    text-decoration: underline;
    &:focus {
      outline: none;
    }
    &:not(.selected) {
      text-decoration: none;
      font-weight: normal;
      cursor: pointer;
      &:hover {
        border-color: inherit;
      }
    }
  }
}
</style>